import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IndexCard } from '../../../auth/store/models';

@Component({
    selector: 'app-statistik-igangvaerende-options',
    templateUrl: './statistik-igangsvaerende-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikIgangsvaerendeOptionsComponent {
    @Input() koncerns: (string | undefined)[] = [];
    @Input() laCards: IndexCard[];
    @Input() kaCards: IndexCard[];
    @Input() saCards: IndexCard[];
    @Input() periode: string;
    @Input() sagskortListe: [];
    @Input() saID: number;
    @Input() kaID: number;
    @Input() laID: number;
    @Output() periodeChange = new EventEmitter<string>();
    @Output() selectKundeAnsvarlig = new EventEmitter<number>();
    @Output() selectLedelseAnsvarlig = new EventEmitter<number>();
    @Output() selectSagsAnsvarlig = new EventEmitter<number>();
    @Output() selectKoncern = new EventEmitter<string>();
    @Output() export = new EventEmitter();
    selectedKoncern?: string;

    onPeriodeChange(periode: string, valid: boolean) {
        if (!valid || !periode) { return; }
        this.periodeChange.emit(periode);
    }

    onSelectKundeAnsvarlig(id: number) {
        this.selectKundeAnsvarlig.emit(id);
    }

    onSelectSagsAnsvarlig(id: number) {
        this.selectSagsAnsvarlig.emit(id);
    }

    onSelectLedelseAnsvarlig(id: number) {
        this.selectLedelseAnsvarlig.emit(id);
    }

    onSelectKoncern(koncernNavn?: string) {
        this.selectedKoncern = koncernNavn;
        this.selectKoncern.emit(koncernNavn);
    }

    findKaName(id: number): string {
        let name = '';
        if (this.kaCards) {
            for (const c of this.kaCards) {
                if (c.cardId === id) {
                    name = c.fornavn + ' ' + c.efternavn;
                    break;
                }
            }
        }
        return name;
    }

    findLaName(id: number): string {
        let name = '';
        if (this.laCards) {
            for (const c of this.laCards) {
                if (c.cardId === id) {
                    name = c.fornavn + ' ' + c.efternavn;
                    break;
                }
            }
        }
        return name;
    }

    findSaName(id: number): string {
        let name = '';
        if (this.saCards) {
            for (const c of this.saCards) {
                if (c.cardId === id) {
                    name = c.fornavn + ' ' + c.efternavn;
                    break;
                }
            }
        }
        return name;
    }

    onExport() {
        this.export.emit();
    }
}
